import { t } from '@/ui/i18n/i18n';
import { h, VNodeChildren } from 'vue';
import { message } from './Message';
import { namedLink } from '@/ui/components/navigation/NamedLink';

export const upgradeMessage = (contents: VNodeChildren, classes: string[] = []) => h('div', {
  class: [
    'upgrade-message',
    ...classes,
  ],
}, [
  message('info', [
    contents,
    h('br'),
    namedLink(t('message.upgrade-plan'), 'subscribe', '', {
      plan: process.env.VUE_APP_PRODUCT_SLUG,
      interval: 'year',
    }),
  ]),
]);
